import React from 'react';

const EmptyState = ({children}) => {
    return (
        <span className='custom-text-grey-200 poppins-regular text-[14px] py-[4px] px-[12px]'>
            {children}
        </span>
    );
};

export default EmptyState;